export default {
  list: {
    material: "材料",
    component: "组件",
    endproduct: "成品",
    fule: "燃料",
    ammo: "弹药",
    power: "电力",
    logistics: "物流",
    collecting: "采集",
    production: "生产",
    turrent: "防御"
  },
  map: {
    items: "组件",
    buildings: "建筑"
  },
  resources: [
    "铁矿",
    "铜矿",
    "硅石",
    "钛石",
    "石矿",
    "煤矿",
    "原油",
    "可燃冰",
    "金伯利矿石",
    "分形硅石",
    "有机晶体",
    "光栅石",
    "刺笋结晶",
    "单极磁石",
    "能量碎片",
    "负熵奇点",
    "物质重组器",
    "硅基神经元",
    "黑雾矩阵",
    "核心素",
    "水",
    "木",
    "沙子"
  ],
  material: [
    "铁块",
    "磁铁",
    "钢材",
    "铜块",
    "高纯硅块",
    "晶格硅",
    "钛块",
    "钛合金",
    "钛化玻璃",
    "石材",
    "玻璃",
    "棱镜",
    "高级石墨",
    "金刚石",
    "硫酸",
    "精炼油",
    "氢",
    "重氢",
    "石墨烯",
    "钛晶石",
    "碳纳米管",
    "塑料",
    "有机晶体",
    "卡西米尔晶体",
    "奇异物质",
    "框架材料",
    "临界光子",
    "反物质",
    "增产剂Mk.Ⅰ",
    "增产剂Mk.Ⅱ",
    "增产剂Mk.Ⅲ"
  ],
  component: [
    "磁线圈",
    "电路板",
    "齿轮",
    "电浆激发器",
    "电动机",
    "电磁涡轮",
    "超级磁场环",
    "微晶元件",
    "处理器",
    "粒子带宽",
    "位面过滤器",
    "量子芯片",
    "引力透镜",
    "粒子容器",
    "光子合并器",
    "戴森球组件",
    "湮灭约束球",
    "空间翘曲器",
    "燃烧单元",
    "爆破单元",
    "晶石爆破单元",
    "动力引擎",
    "推进器",
    "加力推进器",
    "地基"
  ],
  endproduct: [
    "太阳帆",
    "小型运载火箭",
    "液氢燃料棒",
    "氘核燃料棒",
    "反物质燃料棒",
    "奇异湮灭燃料棒",
    "电磁矩阵",
    "能量矩阵",
    "结构矩阵",
    "信息矩阵",
    "引力矩阵",
    "宇宙矩阵",
    "机枪弹箱",
    "钛化弹箱",
    "超合金弹箱",
    "导弹组",
    "超音速导弹组",
    "引力导弹组",
    "炮弹组",
    "高爆炮弹组",
    "晶石炮弹组",
    "等离子胶囊",
    "反物质胶囊",
    "干扰胶囊",
    "压制胶囊",
    "原型机",
    "精准无人机",
    "攻击无人机",
    "护卫舰",
    "驱逐舰"
  ],
  fule: [
    "精炼油",
    "石墨烯",

    "木",
    "煤矿",
    "原油",
    "可燃冰",
    "有机晶体",
    "高级石墨",
    "金刚石",
    "增产剂Mk.Ⅰ",
    "增产剂Mk.Ⅱ",
    "增产剂Mk.Ⅲ",
    "燃烧单元",
    "爆破单元",
    "晶石爆破单元",
    "碳纳米管",
    "氢",
    "重氢",
    "液氢燃料棒",
    "氘核燃料棒",
    "反物质燃料棒",
    "奇异湮灭燃料棒"
  ],
  ammo: [
    "机枪弹箱",
    "钛化弹箱",
    "超合金弹箱",
    "导弹组",
    "超音速导弹组",
    "引力导弹组",
    "炮弹组",
    "高爆炮弹组",
    "晶石炮弹组",
    "等离子胶囊",
    "反物质胶囊",
    "干扰胶囊",
    "压制胶囊"
  ],
  power: [
    "电力感应塔",
    "无线输电塔",
    "卫星配电站",
    "风力涡轮机",
    "火力发电机",
    "太阳能板",
    "蓄电池",
    "蓄电池满",
    "地热发电站",
    "微型聚变发电站",
    "能量枢纽",
    "射线接收站",
    "人造恒星"
  ],
  logistics: [
    "传送带",
    "高速传送带",
    "极速传送带",
    "分拣器",
    "高速分拣器",
    "极速分拣器",
    "四向分流器",
    "集装分拣器",
    "自动集装机",
    "流速监测器",
    "喷涂机",
    "小型储物仓",
    "大型储物仓",
    "储液灌",
    "物流配送器",
    "行星内物流运输站",
    "星际物流运输站",
    "轨道采集器",
    "配送运输机",
    "物流运输机",
    "星际物流运输机"
  ],
  collecting: ["采矿机", "大型采矿机", "抽水机", "原油萃取站"],
  production: [
    "电弧熔炉",
    "位面熔炉",
    "负熵熔炉",
    "制作台Mk.Ⅰ",
    "制作台Mk.Ⅱ",
    "制作台Mk.Ⅲ",
    "重组式制作台",
    "矩阵研究站",
    "自演化研究站",
    "原油精炼厂",
    "分馏塔",
    "化工厂",
    "量子化工厂",
    "微型粒子对撞机",
    "电磁轨道弹射器",
    "垂直发射井"
  ],
  turrent: [
    "高斯机枪塔",
    "导弹防御塔",
    "聚爆加农炮",
    "高频激光塔",
    "磁化电浆炮",
    "近程电浆塔",
    "战场分析基站",
    "干扰塔",
    "信号塔",
    "行星护盾发生器"
  ],
  items: [
    "1-1-铁块",
    "1-2-铜块",
    "1-3-高纯硅块",
    "1-4-钛块",
    "1-5-石材",
    "1-6-高级石墨",
    "1-7-精炼油",
    "1-8-石墨烯",
    "1-9-塑料",
    "1-10-增产剂Mk.Ⅰ",
    "1-11-增产剂Mk.Ⅱ",
    "1-12-增产剂Mk.Ⅲ",
    "1-13-机枪弹箱",
    "1-14-导弹组",
    "2-1-磁铁",
    "2-2-磁线圈",
    "2-3-晶格硅",
    "2-4-钛合金",
    "2-5-玻璃",
    "2-6-金刚石",
    "2-9-有机晶体",
    "2-10-燃烧单元",
    "2-11-爆破单元",
    "2-12-晶石爆破单元",
    "2-13-钛化弹箱",
    "2-14-超音速导弹组",
    "3-1-钢材",
    "3-2-电动机",
    "3-4-钛化玻璃",
    "3-5-棱镜",
    "3-8-钛晶石",
    "3-10-动力引擎",
    "3-11-推进器",
    "3-12-加力推进器",
    "3-13-超合金弹箱",
    "3-14-引力导弹组",
    "4-1-齿轮",
    "4-2-电磁涡轮",
    "4-3-硅石",
    "4-4-电路板",
    "4-5-引力透镜",
    "4-6-硫酸",
    "4-7-氢",
    "4-8-碳纳米管",
    "4-9-奇异物质",
    "4-10-配送运输机",
    "4-11-物流运输机",
    "4-12-星际物流运输机",
    "4-13-等离子胶囊",
    "4-14-炮弹组",
    "5-1-电浆激发器",
    "5-2-超级磁场环",
    "5-3-粒子带宽",
    "5-4-处理器",
    "5-5-卡西米尔晶体",
    "5-6-粒子容器",
    "5-7-重氢",
    "5-9-太阳帆",
    "5-10-框架材料",
    "5-11-戴森球组件",
    "5-12-小型运载火箭",
    "5-13-反物质胶囊",
    "5-14-高爆炮弹组",
    "6-1-光子合并器",
    "6-3-微晶元件",
    "6-4-量子芯片",
    "6-7-位面过滤器",
    "6-8-湮灭约束球",
    "6-9-液氢燃料棒",
    "6-10-氘核燃料棒",
    "6-11-反物质燃料棒",
    "6-12-奇异湮灭燃料棒",
    "6-13-干扰胶囊",
    "6-14-晶石炮弹组",
    "7-1-原型机",
    "7-2-精准无人机",
    "7-3-攻击无人机",
    "7-4-护卫舰",
    "7-5-驱逐舰",
    "7-6-空间翘曲器",
    "7-7-临界光子",
    "7-8-反物质",
    "7-13-压制胶囊",
    "7-14-地基",
    "8-1-电磁矩阵",
    "8-2-能量矩阵",
    "8-3-结构矩阵",
    "8-4-信息矩阵",
    "8-5-引力矩阵",
    "8-6-宇宙矩阵"
  ],
  buildings: [
    "1-1-电力感应塔",
    "1-2-无线输电塔",
    "1-3-卫星配电站",
    "1-4-风力涡轮机",
    "1-5-火力发电机",
    "1-6-太阳能板",
    "1-7-蓄电池",
    "1-100-蓄电池满",
    "1-8-地热发电站",
    "1-9-微型聚变发电站",
    "1-10-能量枢纽",
    "1-11-射线接收站",
    "1-12-人造恒星",
    "2-1-传送带",
    "2-2-高速传送带",
    "2-3-极速传送带",
    "2-4-四向分流器",
    "2-5-自动集装机",
    "2-6-流速监测器",
    "2-7-喷涂机",
    "2-8-小型储物仓",
    "2-9-大型储物仓",
    "2-10-储液灌",
    "2-11-物流配送器",
    "2-12-行星内物流运输站",
    "2-13-星际物流运输站",
    "2-14-轨道采集器",
    "3-1-分拣器",
    "3-2-高速分拣器",
    "3-3-极速分拣器",
    "3-4-集装分拣器",
    "3-5-采矿机",
    "3-6-大型采矿机",
    "3-7-抽水机",
    "3-8-原油萃取站",
    "3-9-原油精炼厂",
    "3-10-分馏塔",
    "3-11-化工厂",
    "3-12-量子化工厂",
    "3-13-微型粒子对撞机",
    "4-1-电弧熔炉",
    "4-2-位面熔炉",
    "4-3-负熵熔炉",
    "4-4-制作台Mk.Ⅰ",
    "4-5-制作台Mk.Ⅱ",
    "4-6-制作台Mk.Ⅲ",
    "4-7-重组式制作台",
    "4-8-矩阵研究站",
    "4-9-自演化研究站",
    "4-10-电磁轨道弹射器",
    "4-11-垂直发射井",
    "5-1-高斯机枪塔",
    "5-2-导弹防御塔",
    "5-3-聚爆加农炮",
    "5-4-高频激光塔",
    "5-5-磁化电浆炮",
    "5-6-近程电浆塔",
    "5-7-战场分析基站",
    "5-8-干扰塔",
    "5-9-信号塔",
    "5-10-行星护盾发生器"
  ]
};
